<template>
  <div
    class="on-board-card text-white d-flex flex-column justify-content-between"
  >
    <h2 class="mb-5 pt-2 text-center">{{ "onboard.card.title" | trans }}</h2>

    <div
      v-if="isRequested"
      class="mb-4"
      v-html="$trans('onboard.card.card_optin.requested_desc')"
    ></div>
    <div
      v-else-if="!canOptIn"
      class="mb-4"
      v-html="$trans('onboard.card.card_optin.already_desc')"
    ></div>
    <app-add-card-form v-if="canAddCard" />
    <app-card-opt-in-form v-if="canOptIn" class="mt-5" />

    <div class="mt-5">
      <app-button size="lg" block variant="light" @click="onChangeUser">
        <i class="icon icon-arrow-left"></i>
        {{ "onboard.card.button.change_user.label" | trans }}
      </app-button>

      <app-button block :href="$trans('onboard.card.button.get_help.link')">{{
        "onboard.card.button.get_help.label" | trans
      }}</app-button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppAddCardForm from "@/views/Account/OnBoard/Card/AddCardForm";
import AppCardOptInForm from "@/views/Account/OnBoard/Card/CardOptInForm";
import AppButton from "@/components/ui/Button";

export default {
  name: "OnBoardCardView",
  components: { AppButton, AppCardOptInForm, AppAddCardForm },
  computed: {
    ...mapGetters("customers", ["customer"]),
    canAddCard() {
      return this.customer && this.customer.canAddCard;
    },
    canOptIn() {
      return this.customer && !this.customer.isCardOptedIn;
    },
    isRequested() {
      return this.customer && this.customer.isCardRequested;
    },
  },
  methods: {
    async onChangeUser() {
      await this.$auth.logout();
      this.$router.push({ name: "login" });
    },
  },
};
</script>

<style lang="scss" scoped>
.on-board-card {
  ::v-deep {
    .custom-checkbox {
      a {
        color: $white;
        text-decoration: underline;
      }
    }
  }
}
</style>
